import React, { Component } from "react"
import { searchTableFilter } from "../Tree/Utils.js"
import { maleFemaleOther, kidParents, kidMisgeret } from '../../variables/ComboValues'
import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB
// export for translation only
export const  Kids_microLegend = { 
    "kid_family_name": "שם משפחה",
    "kid_first_name": "שם פרטי",
    "kid_birthdate": "ת. לידה",
    "kid_gender": "מין",
    "kid_parents": "שייכות להורים",
    "kid_misgeret": "באיזו מסגרת",
    "kid_comment": "הערות"
}

export class FamilyKids extends Component {

    constructor(props) {
      super(props)
      this.state = {products: this.props.data, sortASC:"true"}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleAddEvent = this.handleAddEvent.bind(this)
      this.handleRowDel = this.handleRowDel.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
      this.handleSort = this.handleSort.bind(this)
    }
    compareDates(a, b){
      let a_s = a.split('/').map(item => parseInt(item))
      let b_s = b.split('/').map(item => parseInt(item))
      //console.log("compare a b", a_s, b_s)
      let i = a_s.length
      while (i-- >= 0) // compare year, month, day
        if (a_s[i] !== b_s[i]){
          if (a_s[i] > b_s[i]) return 1
          return -1
        }
      return 0
    }
    handleSort(evt){
      evt.preventDefault();
      let sorted = [...this.state.products]
      let dir = this.state.sortASC ? 1 : -1
      sorted.sort((a, b) => dir * this.compareDates(a['kid_birthdate'], b['kid_birthdate']))
      this.setState({products:sorted, sortASC: !this.state.sortASC })
    }
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      //this.state.products.splice(index, 1)
      array.splice(index, 1)
      this.setState({products:array})
    }
    /*
    handleRowDel(product) {
      var index = this.state.products.indexOf(product)
      this.state.products.splice(index, 1)
      this.setState(this.state.products)
    }*/
  
    handleAddEvent(evt) {
      evt.preventDefault()
      const id = (+ new Date() + Math.floor(Math.random() * 9999999)).toString(36);
      const familyName = this.state.products[0] !== undefined ? this.state.products[0]['kid_family_name'] : ""
      //let d = digmaDate(Date())
      var product = {
        id: id,
        kid_family_name: familyName,
        kid_first_name: "",
        kid_birthdate: "",
        kid_gender: "",
        kid_parents: "",
        kid_misgeret: "",
        kid_comment: ""
      }
      let newp = ""
      if (typeof this.state.products === "undefined"  || this.state.products === false){
        newp = [product]
      } else {
        newp = Object.assign(this.state.products)
        newp.unshift(product)
      }
      this.setState({products:newp})
      //this.state.products.unshift(product)
      //this.setState(this.state.products)
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      //console.log("Meeting summary save table: products", this.state.products)
   
      save2DB(familyPostId, this.state.products, subTableId, "table", inUpdate, mbouser )
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }
    render() {
      let title = this.props.tableTitle === undefined? "סיכומי מפגשים" : this.props.tableTitle
      //const { data } = this.props
      //console.log("meeting data", data)
      //console.log("OLD meeting data", this.state.products)

      return (
        <div>
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            headerColumns = {["kid_family_name","kid_first_name","kid_birthdate","kid_gender","kid_parents","kid_misgeret","kid_comment"]}
            tableTitle = {title} 
            onRowAdd={this.handleAddEvent} 
            onRowDel={this.handleRowDel} 
            onSort = {this.handleSort}
            sortASC = {this.state.sortASC}
            products={this.state.products} 
            onProductTableDate={this.handleProductTableDate}
          />
        </div>
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() { 
      const { onProductTableUpdate, onRowDel, onSort, onRowAdd, headerColumns, products, tableTitle, onSaveTable, onProductTableDate  } = this.props
      var filterText = this.state.filterText;
      var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
      var buttonStyle = {marginRight: '0'}
      var searchbarStyle = {margin: '5px 10px'}
      var product = (typeof products === "undefined")? null : products.map(function(product) {
      //var product = products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;
        
        const cellData=[{
            type: "text",
            name: "kid_family_name",
            value: product.kid_family_name,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "text",
            name: "kid_first_name",
            value: product.kid_first_name,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "text",
            name: "kid_birthdate",
            value: product.kid_birthdate,
            id: product.id,
            style: {width: "90px"},
            placeholder: 'dd/mm/yyyy',
            edit: true
          },{
            type: "select",
            options: maleFemaleOther, // ["זכר","נקבה","אחר"],
            name: "kid_gender",
            value: product.kid_gender,
            id: product.id,
            style: {width: "60px"},
            edit: true
          },{
            type: "select",
            options: kidParents, // ["לשני ההורים","לאמא","לאבא","אחר"],
            name: "kid_parents",
            value: product.kid_parents,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "select",
            options: kidMisgeret, // ["מעון/ משפחתון","גן","בית ספר יסודי","בית ספר חטיבת ביניים","בית ספר תיכון","שרות צבאי","שרות לאומי",
            //"לימודים בישיבה קטנה","לימודים בישיבה גבוהה","לימודים בישיבת הסדר","לימודים במכינה קדם צבאית","לימודים בכולל",
            //"עובד","ללא מסגרת","אחר"],
            name: "kid_misgeret",
            value: product.kid_misgeret,
            id: product.id,
            style: {width: "140px"},
            edit: true
          },{
            type: "textarea",
            name: "kid_comment",
            value: product.kid_comment,
            id: product.id,
            style: {width: "200px"},
            edit: true
          }] 
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            onProductTableDate = { onProductTableDate}
            key={product.id}
            cd={cellData}
            />)
      })

      return (
        <div className="yahav-modal">
            <h2>{tableTitle}&nbsp;(סה"כ&nbsp;{typeof products === "undefined"? 0 : products.length})</h2>
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת ילד/ה</button>
            <button style={buttonStyle} type="button" onClick={onSort} className="btn btn-success pull-right">
            מיון לפי ת. לידה {this.props.sortASC ? <span>&darr;</span> : <span>&uarr;</span>}</button>
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>{Kids_microLegend[col]?Kids_microLegend[col] : col}</th>) 
                  }) } 
                    </tr>
                </thead>  
                <tbody>
                    {product}
                </tbody>
            </table>
        </div>
      )
    }
  }
 